import React, { useEffect } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import FormWrapper from 'components/atoms/FormWrapper';
import { ERouteLinks } from 'models/route';
import { useLegalEntities } from 'pages/LegalEntitiesPage/hooks';
import { useQuery } from 'hooks/useQuery';
import { ELegalEntityTypes, ELegalEntityTypesLabel } from 'constants/LegalEntityTypes';
import { useParams } from 'react-router-dom';
import { StyledPageTitle } from 'theme/styles';
import {
  ILegalEntityPreviousNamesSurnamesFormValues,
  LegalEntityPreviousNamesSurnamesForm,
} from 'pages/LegalEntitiesPage/LegalEntityPreviousNamesSurnamesForm';
import { useTranslations } from 'hooks/useTranslations';

const LegalEntityEditPreviousNamesSurnamesPage = () => {
  const { id = '', previousNamesSurnamesId = '' } = useParams<{
    id: string;
    previousNamesSurnamesId: string;
  }>();
  const query = useQuery();
  const type: string | null = query.get('type')?.trim() || null;
  const {
    handleEditPreviousNamesSurnames,
    getLegalEntityPreviouNameSurnameData,
    legalEntityPreviousNamesSurnamesDetail,
    navigateToDetails,
  } = useLegalEntities();
  const { t } = useTranslations();

  useEffect(() => {
    (async function getLEPreviousNamesSurnamesDataInit() {
      if (previousNamesSurnamesId && !legalEntityPreviousNamesSurnamesDetail) {
        getLegalEntityPreviouNameSurnameData(previousNamesSurnamesId);
      }
    })();
  }, [previousNamesSurnamesId]);

  const handleSubmit = async (data: ILegalEntityPreviousNamesSurnamesFormValues) => {
    const result = await handleEditPreviousNamesSurnames(previousNamesSurnamesId, data);
    if (result) {
      navigateToDetails();
    }
  };

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('module.legalEntity.name'), route: ERouteLinks.LegalEntities },
          {
            label:
              type === ELegalEntityTypes.individual
                ? t('legalEntities.individual.accordion.label')
                : t('legalEntities.organization.accordion.label'),
            route: `${ERouteLinks.LegalEntities}?expand=${
              type === ELegalEntityTypes.individual
                ? ELegalEntityTypesLabel.individual
                : ELegalEntityTypesLabel.organisation
            }`,
          },
          {
            label: t('legalEntityDetails.legalEntityDetails.text'),
            route: `${ERouteLinks.ViewLegalEntity.replace(
              ':id',
              id,
            )}?type=${type}&expand=previousNamesSurnames`,
          },
          t('legalEntityDetails.previousNamesSurnames.accordion.label'),
          t('legalEntityDetails.previousNamesSurnames.edit.header'),
        ]}
      />
      {legalEntityPreviousNamesSurnamesDetail && (
        <>
          <StyledPageTitle variant="h4">
            {t('legalEntityDetails.previousNamesSurnames.edit.header')}
          </StyledPageTitle>

          <FormWrapper>
            <LegalEntityPreviousNamesSurnamesForm
              onCancel={navigateToDetails}
              onSubmit={handleSubmit}
              isEdit
              initialFormValues={{
                firstName: legalEntityPreviousNamesSurnamesDetail.firstName,
                middleNames: legalEntityPreviousNamesSurnamesDetail.middleNames ?? '',
                lastName: legalEntityPreviousNamesSurnamesDetail.lastName,
                version: legalEntityPreviousNamesSurnamesDetail.version,
              }}
            />
          </FormWrapper>
        </>
      )}
    </>
  );
};

export { LegalEntityEditPreviousNamesSurnamesPage };
